import React, { useEffect, useState } from "react";
import { Flex, Box, Spacer, Select, Text, IconButton } from "@chakra-ui/react";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../community/components/list-community.css";
import { RepeatIcon } from "@chakra-ui/icons";

function FilterListContent() {
  const { search } = useLocation();
  const history = useHistory();
  const [sort, setSort] = useState("");
  const [firstDate, setFirstDate] = useState("");
  const [lastDate, setLastDate] = useState("");

  const changeSortHandler = (event) => {
    setSort(event.target.value);
    const currentQuery = queryString.parse(search);
    const query = queryString.stringify({
      ...currentQuery,
      sort: event.target.value,
    });

    history.push(`/commission/list-commission?${query}`);
  };

  const changeDateHandler = ({ event, type }) => {
    const formatDate = (d) => {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const date = formatDate(event);
    const today = formatDate(new Date());

    const currentQuery = queryString.parse(search);
    const queries = queryString.stringify({
      ...currentQuery,
      periodStart:
        type === "min" ? date : firstDate === "" ? date : firstDate,
      periodEnd: type === "max" ? date : lastDate === "" ? today : lastDate,
    });

    history.push(`/commission/list-commission?${queries}`);
  };

  useEffect(() => {
    const currentQuery = queryString.parse(search);
    if (currentQuery.sort) {
      setSort(currentQuery.sort);
    }
    if (currentQuery.periodStart) {
      setFirstDate(currentQuery.periodStart);
    }
    if (currentQuery.periodEnd) {
      setLastDate(currentQuery.periodEnd);
    }
  }, [search]);

  return (
    <Flex gap="48px">
      <Box>
        <Flex align="center">
          <Text mr="16px" color="black" fontSize="16px" mb="0">
            Sort By
          </Text>
          <Select
            width="120px"
            value={sort}
            onChange={(event) => changeSortHandler(event)}
          >
            <option value="name,desc">A-Z</option>
            <option value="name,asc">Z-A</option>
            <option value="totalCommission,asc">Terkecil</option>
            <option value="totalCommission,desc">Terbesar</option>
          </Select>
        </Flex>
      </Box>
      <Box>
        <Flex className="promo-list__datepicker__container">
          <Text className="promo-list__datepicker-text" mb="0">Filter Period</Text>
          <DatePicker
            selected={firstDate ? new Date(firstDate) : firstDate}
            onChange={(event) => changeDateHandler({ event, type: "min" })}
            dateFormat="dd/MM/yyyy"
            maxDate={lastDate ? new Date(lastDate) : new Date()}
          />
          -
          <DatePicker
            selected={lastDate ? new Date(lastDate) : lastDate}
            onChange={(event) => changeDateHandler({ event, type: "max" })}
            dateFormat="dd/MM/yyyy"
            minDate={new Date(firstDate)}
            maxDate={new Date()}
          />
        </Flex>
      </Box>
    </Flex>
  );
}

export default FilterListContent;
